// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__wwVIn","header":"PatientBlock_header__UqeTr","label":"PatientBlock_label__2swXe","option":"PatientBlock_option__2tp1s"};